/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ConsumerTaskObjectType {
    BatesZip = 0,
    CaseZip = 1,
    InterrogatoryZip = 2,
    SimilarRequest = 3,
    AutoObject = 4
}

export function ConsumerTaskObjectTypeFromJSON(json: any): ConsumerTaskObjectType {
    return ConsumerTaskObjectTypeFromJSONTyped(json, false);
}

export function ConsumerTaskObjectTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConsumerTaskObjectType {
    return json as ConsumerTaskObjectType;
}

export function ConsumerTaskObjectTypeToJSON(value?: ConsumerTaskObjectType | null): any {
    return value as any;
}

